import { render, staticRenderFns } from "./ProviderFeatures.vue?vue&type=template&id=4b588a93"
import script from "./ProviderFeatures.vue?vue&type=script&lang=js"
export * from "./ProviderFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports